
export class OperationDualWallet {

    id:number;
    msisdn:string;
    montant:number;
    loginPdg:string;
    messageRetour:string;
    status:string;
    secret:string;
    dateOperation:any;

    constructor() { }
}
